import { defineMessage } from 'services/localization';

export const messages = {
    resendButton: defineMessage('resend_a_quote'),
    quoteWasSuccessfullyResent: defineMessage('the_quote_was_successfully_resent'),
};
